import "./style.css";

export const VinylCard = ({ coverSrc, link, artist, name, year }) => {
  return (
    <div>
      <a
        href={link}
        target="_blank"
        rel="noreferrer"
        className="d-flex justify-content-center flex-wrap grid__link text-decoration-none"
      >
        <div className="coverMain position-relative">
          <img src={coverSrc} alt={name} className="img-fluid" />
          <svg class="lp lp--grid"></svg>
          <div className="vinylYear">{year}</div>
        </div>
        <div className="vinylText text-left w-100">
          <h6 className="vinylTitle">{artist}</h6>
          <small className="vinylName">{name}</small>
        </div>
      </a>
    </div>
  );
};
